import { useCallback, useState } from "react";
import { useIntl } from "react-intl";
import type { DataTableFilter } from "~components/DataTable/types/dataTableFilter.ts";
import SelectCountryCode from "~components/SelectCountryCode/SelectCountryCode.tsx";
import SelectVenueStatus from "~components/SelectVenueStatus/SelectVenueStatus.tsx";
import { TableFilter } from "~enums/tableFilter.ts";
import { VenueTableFilterTypes } from "~pages/Venues/enums/venueTableFilterTypes.ts";

export const useGetVenueTableFilters = (): {
  filters: DataTableFilter[];
  currentFilter: Record<string, any>;
  handleFilterChange: (updatedFilter: Record<string, any>) => void;
} => {
  const [currentFilter, setCurrentFilter] = useState<Record<string, any>>({});
  const { formatMessage } = useIntl();

  const handleFilterChange = useCallback((updatedFilter: Record<string, any>) => {
    setCurrentFilter(updatedFilter);
  }, []);

  const filters = [
    {
      filterKey: VenueTableFilterTypes.CountryCode,
      tableFilterType: TableFilter.Primary,
      filterElement: (props: { value: any; onChange: (value: any) => void }) => (
        <SelectCountryCode
          onChange={props.onChange}
          value={props.value}
          placeholder={formatMessage({
            id: "dataTable.filters.countryCode.allOption",
          })}
        />
      ),
    },
    {
      filterKey: VenueTableFilterTypes.Status,
      tableFilterType: TableFilter.Primary,
      filterElement: (props: { value: any; onChange: (value: any) => void }) => (
        <SelectVenueStatus onChange={props.onChange} value={props.value} placeholder={formatMessage({ id: "status" })} />
      ),
    },
  ];

  return {
    filters: filters,
    currentFilter: currentFilter,
    handleFilterChange: handleFilterChange,
  };
};
